"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var schemaRef_exports = {};
__export(schemaRef_exports, {
  schemaRef: () => schemaRef,
  schemaRefAll: () => schemaRefAll
});
module.exports = __toCommonJS(schemaRef_exports);
var import_lodash = require("lodash");
var import_create = require("./create.js");
var import_typeCheck = require("./typeCheck.js");
function sumSchemaRef(products, path) {
  const schemas = (0, import_lodash.values)(products).reduce((memo, schema) => [...memo, ...schemaRefAll(schema, path)], []);
  return (0, import_lodash.uniqWith)(schemas, import_lodash.isEqual);
}
function ensureNullable(schema) {
  switch (schema.type) {
    case "Nullable":
      return schema;
    default:
      return (0, import_create.nullableSchema)(schema);
  }
}
function schemaRefAll(schema, path) {
  if (path.length === 0) {
    return [schema];
  } else if (typeof path[0] === "string") {
    switch (schema.type) {
      case "Dict": {
        const [head, ...tail] = path;
        if ((0, import_typeCheck.typeCheck)(schema.key, head).length === 0) {
          return schemaRefAll(schema.value, tail).map(ensureNullable);
        } else {
          return [];
        }
      }
      case "Product": {
        const [head, ...tail] = path;
        const fieldSchema = schema.fields[head];
        return fieldSchema == null ? [] : schemaRefAll(fieldSchema, tail);
      }
      case "Sum": {
        return sumSchemaRef(schema.products, path);
      }
      default:
        return [];
    }
  } else {
    switch (schema.type) {
      case "Array": {
        const [, ...tail] = path;
        return schemaRefAll(schema.param, tail);
      }
      case "Tuple": {
        const [head, ...tail] = path;
        const fieldSchema = schema.items[head] || null;
        return schema == null ? [] : schemaRefAll(fieldSchema, tail);
      }
      case "Sum": {
        return sumSchemaRef(schema.products, path);
      }
      default:
        return [];
    }
  }
}
function schemaRef(schema, path) {
  const results = schemaRefAll(schema, path);
  if (results.length === 1) {
    return results[0];
  } else {
    return void 0;
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  schemaRef,
  schemaRefAll
});
//# sourceMappingURL=schemaRef.js.map
